import { createAsyncThunk } from "@reduxjs/toolkit";
import { AIappServiceName } from "../../utils/environment";

import myContractServices from "./../../Services/MycontractServices";
import { ResponseMessageHandler } from "../../globals/components/notification";
import { Getsubobligationdata } from "../MyObligation/MyObligation.Action";
import { getTaskactivitylist, getTaskdetails } from "../MyTask/MyTask.Action";
import {
  getDetails,
  getStaffList,
  getVendordetailsList,
} from "../Taskmanagement/Taskmanagement.Action";
import { setDrawerVisible } from "../Taskmanagement/Taskmanagement.Slice";
import { onMenuClickchanges } from "../../globals/layout/layout.slice";
import { checkAuthorization } from "../../utils/helper";
import { setIsAuthenticated } from "../users/user.slice";
import {
  appendAIMessage,
  setActiveSession,
  setAITyping,
  setisAcceptorRejectObligationRecord,
  setThreadId,
  showError,
  showFinalAnswer,
  showIntermediateResponse,
  showThinking,
  showToolResult,
  showToolUsage,
  startAITyping,
} from "./myContract.Slice";
import { setObligationdatareset } from "../Workflow/Workflow.slice";
import { getCreditsDetailByCompanyId } from "../Company/company.action";

export const getContracts = createAsyncThunk(
  "contract/getContracts",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getContractsAPI({
        ...data,
        limit: data.pageSize,
        page: data.current,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createTask = createAsyncThunk(
  "task/createTask",
  async ({ data, taskPagination }, thunkAPI) => {
    try {
      const res = await myContractServices.createTaskAPI(data);
      // thunkAPI.dispatch(getTaskdetails(taskPagination));
      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractsforcompany = createAsyncThunk(
  "contract/getContractsforcompany",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getContractsforcompanyAPI({
        ...data,
        limit: data.pageSize,
        page: data.current,
      });
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getbuckets = createAsyncThunk(
  "contract/getbuckets",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getbucketsAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getVendorLists = createAsyncThunk(
  "contract/getVendorLists",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getVendorListsAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getContractByVendor = createAsyncThunk(
  "contract/getContractByVendor",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getContractByVendorAPI(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAddendumTask = createAsyncThunk(
  "contract/getAddendumTask",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getAddendumTaskAPi(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getContractDetails = createAsyncThunk(
  "contract/getContractDetails",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getContractDetailAPi(data);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getcontractVerify = createAsyncThunk(
  "contract/getcontractVerify",
  async (data, thunkAPI) => {
    try {
      const { form_data } = data;
      let res = await myContractServices.getgetcontractVerifyAPI(form_data);
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAcceptorrejectobligation = createAsyncThunk(
  "contract/getAcceptorrejectobligation",
  async ({ data, obgpageSubobligationData, contractId }, thunkAPI) => {
    try {
      let res = await myContractServices.getAcceptorrejectobligationAPI(data);
      if (!data?.notCallRest) {
        thunkAPI.dispatch(Getsubobligationdata(obgpageSubobligationData));
        thunkAPI.dispatch(getContractDetails({ contractId }));
      }

      thunkAPI.dispatch(
        setisAcceptorRejectObligationRecord({
          visible: true,
          status: data?.obligationStatus === 7 ? 1 : 0,
        })
      );
      // ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createAddendumforTasks = createAsyncThunk(
  "task/createAddendumforTasks",
  async ({ data, taskPagination }, thunkAPI) => {
    try {
      const res = await myContractServices.createAddendumforTasksAPI(data);

      thunkAPI.dispatch(setDrawerVisible({ visible: true, record: res.data }));
      thunkAPI.dispatch(getDetails({ taskId: res.data._id }));
      thunkAPI.dispatch(
        getVendordetailsList({
          sortBy: "DESC",
          status: true,
          orderBy: "createdAt",
          is_from_task: true,
        })
      );
      thunkAPI.dispatch(getStaffList());
      thunkAPI.dispatch(getTaskactivitylist({ taskId: res.data._id }));
      thunkAPI.dispatch(getTaskdetails(taskPagination));
      thunkAPI.dispatch(onMenuClickchanges("task_management"));
      localStorage.setItem("dynamic_url_path", `/task_management`);

      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createRenewofTasks = createAsyncThunk(
  "task/createRenewofTasks",
  async ({ data, taskPagination }, thunkAPI) => {
    try {
      const res = await myContractServices.createRenewofTasksAPI(data);

      thunkAPI.dispatch(onMenuClickchanges("task_management"));
      localStorage.setItem("dynamic_url_path", `/task_management`);

      thunkAPI.dispatch(setDrawerVisible({ visible: true, record: res.data }));
      thunkAPI.dispatch(getDetails({ taskId: res.data._id }));
      thunkAPI.dispatch(
        getVendordetailsList({
          sortBy: "DESC",
          status: true,
          orderBy: "createdAt",
          is_from_task: true,
        })
      );
      thunkAPI.dispatch(getStaffList());
      thunkAPI.dispatch(getTaskactivitylist({ taskId: res.data._id }));
      thunkAPI.dispatch(getTaskdetails(taskPagination));

      ResponseMessageHandler(res);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getRenewalsInfoOfContract = createAsyncThunk(
  "contract/getRenewalsInfoOfContract",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getRenewalsInfoOfContractAPI(data);
      // thunkAPI.dispatch(Getsubobligationdata(obgpageSubobligationData));
      // ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getarchiveContracts = createAsyncThunk(
  "contract/getarchiveContracts",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getarchiveContractsAPI(data);
      // thunkAPI.dispatch(Getsubobligationdata(obgpageSubobligationData));
      // ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const createChildContracts = createAsyncThunk(
  "contract/createChildContracts",
  async ({ data, taskPagination }, thunkAPI) => {
    try {
      let res = await myContractServices.createChildContractsAPI(data);
      thunkAPI.dispatch(onMenuClickchanges("task_management"));
      localStorage.setItem("dynamic_url_path", `/task_management`);

      thunkAPI.dispatch(setDrawerVisible({ visible: true, record: res.data }));
      thunkAPI.dispatch(getDetails({ taskId: res.data._id }));
      thunkAPI.dispatch(
        getVendordetailsList({
          sortBy: "DESC",
          status: true,
          orderBy: "createdAt",
          is_from_task: true,
        })
      );
      thunkAPI.dispatch(getStaffList());
      thunkAPI.dispatch(getTaskactivitylist({ taskId: res.data._id }));
      thunkAPI.dispatch(getTaskdetails(taskPagination));
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getFamilyContractInfo = createAsyncThunk(
  "contract/getFamilyContractInfo",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getFamilyContractDetailsAPI(data);
      // thunkAPI.dispatch(Getsubobligationdata(obgpageSubobligationData));
      // ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const CreateRelationwithContracts = createAsyncThunk(
  "contract/CreateRelationwithContracts",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.CreateRelationwithContractsAPI(data);
      thunkAPI.dispatch(
        getFamilyContractInfo({
          contractId: data?.currentContractId || res.data._id,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getLinkageDropdownList = createAsyncThunk(
  "contract/getLinkageDropdownList",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getLinkageDropdownListAPI(data);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const streamAIsearchww = (data) => async (dispatch) => {
  try {
    dispatch(startAITyping());

    const res = await fetch(`${AIappServiceName}/conversation/contracts/chat`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) throw new Error("Failed to fetch stream");

    const reader = res.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let partialText = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      partialText += chunk;

      const messages = partialText.split("\n\n");
      partialText = messages.pop(); // keep any incomplete tail

      for (const msg of messages) {
        if (msg.startsWith("data: ")) {
          const raw = msg.replace("data: ", "").trim();
          if (!raw) continue;

          try {
            const dataObj = JSON.parse(raw);

            switch (dataObj.type) {
              case "thought":
                dispatch(showThinking(dataObj.content));
                break;
              case "action":
                dispatch(
                  showToolUsage(dataObj.metadata?.tool_name || "Unknown Tool")
                );
                break;
              case "response":
                if (dataObj.metadata?.event_type === "observation") {
                  dispatch(showToolResult(dataObj.content));
                } else if (dataObj.metadata?.final) {
                  dispatch(showFinalAnswer(dataObj.content));
                } else {
                  dispatch(showIntermediateResponse(dataObj.content));
                }
                break;
              case "error":
                dispatch(showError(dataObj.content));
                break;
              default:
                // If not structured, fallback to simple message
                dispatch(
                  appendAIMessage({
                    id: `${Date.now()}`,
                    text: dataObj.content || raw,
                    sender: "bot",
                    timestamp: new Date(),
                  })
                );
            }
          } catch (err) {
            // Not JSON or malformed
            console.warn("Failed to parse message as JSON:", raw);
          }
        }
      }
    }

    dispatch(setAITyping(false));
  } catch (error) {
    console.error("Stream error:", error);
    dispatch(setAITyping(false));
  }
};
export const streamAIsearch = createAsyncThunk(
  "contract/streamAIsearch",
  async ({ data, sessionPayload }, thunkAPI) => {
    try {
      let res = await myContractServices.getAIserachAPI(data);
      thunkAPI.dispatch(getCreditsDetailByCompanyId({}));

      if (data.type === "new") {
        thunkAPI.dispatch(setThreadId(res.thread_id));
        thunkAPI.dispatch(getSessions(sessionPayload));
        thunkAPI.dispatch(setActiveSession(res.thread_id));
      }
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const streamAIsearchold = createAsyncThunk(
  "contract/streamAIsearchold",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getAIseracholdAPI(data);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addObligationsToContract = createAsyncThunk(
  "contract/addObligationToContract",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.addObligationToContractAPI(data);
      ResponseMessageHandler(res);
      thunkAPI.dispatch(setObligationdatareset());
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAddendumListByContractId = createAsyncThunk(
  "contract/getAddendumListByContractId",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.getAddendumListByContractIdAPI(data);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSessions = createAsyncThunk(
  "chat/getSessions",
  async (params, thunkAPI) => {
    try {
      // params = { user_id, company_id, limit, skip }
      const res = await myContractServices.getSessionsAPI(params);
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();

      // Handle API error response globally
      ResponseMessageHandler(error.response?.data);

      // If token/session expired, log out
      if (checkAuthorization(error.response?.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }

      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getChatBySessionsId = createAsyncThunk(
  "contract/getChatBySessionsId",
  async (data, thunkAPI) => {
    try {
      // params = { user_id, company_id, limit, skip }
      const res = await myContractServices.getChatBySessionsIdAPI(
        data.thread_id
      );
      thunkAPI.dispatch(setThreadId(data.thread_id));
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();

      // Handle API error response globally
      ResponseMessageHandler(error.response?.data);

      // If token/session expired, log out
      if (checkAuthorization(error.response?.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }

      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const RiskAnalysisAI = createAsyncThunk(
  "contract/RiskAnalysisAI",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.RiskAnalysisAI(data);
      thunkAPI.dispatch(getCreditsDetailByCompanyId({}));
      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteRelationwithContracts = createAsyncThunk(
  "contract/deleteRelationwithContracts",
  async (data, thunkAPI) => {
    try {
      let res = await myContractServices.deleteRelationwithContractsAPI(data);
      thunkAPI.dispatch(
        getFamilyContractInfo({
          contractId: data?.contract1 || res.data._id,
        })
      );
      ResponseMessageHandler(res);

      return res;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.error) ||
        error.message ||
        error.toString();
      ResponseMessageHandler(error.response.data);
      if (checkAuthorization(error.response.data)) {
        thunkAPI.dispatch(setIsAuthenticated(false));
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);
